function RibbonDirective() {
	return {
		restrict: 'EA',
		template: require('./ribbon-template.html'),
		scope: {
			className: '=',
			label: '='
		}
	};
}

module.exports = RibbonDirective;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/customer-reviews/cards/ribbon-directive.js
 **/